import { useController, useFormContext, type FieldValues, type Path } from "react-hook-form";
import NewCustomColorPicker from "../NewCustomColorPicker/NewCustomColorPicker";
import { useVariantFieldDisabled } from "./context/VariantFieldContext";

export interface FormColorPickerProps<TFieldValues extends FieldValues = FieldValues> {
    name: Path<TFieldValues> | (string & NonNullable<unknown>);
    label: string;
    disabled?: boolean;
}

export function FormColorPicker<TFieldValues extends FieldValues = FieldValues>({
    name,
    label,
    disabled,
}: FormColorPickerProps<TFieldValues>) {
    const { control } = useFormContext<TFieldValues>();
    const {
        field,
        fieldState: { error },
    } = useController<TFieldValues>({ control, name: name as any });

    const isAbDisabled = useVariantFieldDisabled(name as string);

    return (
        <NewCustomColorPicker
            hexColor={String(field.value ?? "#ffffff")}
            setHexColor={(val) => field.onChange(val)}
            label={label}
            disabled={disabled || isAbDisabled}
            props={{
                ...field,
                error: error?.message,
            }}
        />
    );
}
